import React from "react";

const CardLabelProfile = ({ title, children }) => {
  return (
    <div className="rounded-large bg-white border p-xxl-4 p-3 mt-4">
      <div className="px-3">
        <h4>{title}</h4>
      </div>
      {children}
    </div>
  );
};

export default CardLabelProfile;
